<div class="toggle" role="group" aria-label="Период на графиките">
  @for (opt of options; track opt.months) {
    <button type="button" [class.active]="value() === opt.months" (click)="change.emit(opt.months)">
      {{ opt.label }}
    </button>
  }
</div>
